import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import {
  IconNumberTextWidgetSize,
  IconNumberTextWidgetVariant
} from '@uigy/shared/components/ui-data-widgets/ui-icon-number-text-widget/interfaces';


@Component({
    selector: 'app-ui-icon-number-text-widget',
    imports: [
    NgClass
],
    templateUrl: './icon-number-text-widget.component.html',
    styleUrl: './icon-number-text-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconNumberTextWidgetComponent {
  public numberValue = input<number | undefined>(undefined);
  public title = input<string>('');
  public numeratorClass = input<string>('');
  public withDenominator = input<boolean>(true);
  public variant = input<IconNumberTextWidgetVariant>(IconNumberTextWidgetVariant.orange);
  public size = input<IconNumberTextWidgetSize>(IconNumberTextWidgetSize.large);
  public isResponsive = input<boolean>(false);
}

